import { render, staticRenderFns } from "./PageForgotPasswordSet.vue?vue&type=template&id=6c1d6eff&"
import script from "./PageForgotPasswordSet.vue?vue&type=script&lang=ts&"
export * from "./PageForgotPasswordSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports